import React from 'react';
import { Auth } from 'aws-amplify';
import { useTranslation } from 'react-i18next';
import { Button } from 'antd';
import { useRouter } from '@hooks/useRouter';
import { css } from '@emotion/react';
import useRuntimeConfig from '@vl-core/hooks/useConfig';
import Hint from '@components/Login/Hint';

const SelfRegLink = () => {
  const { t } = useTranslation('common');
  const { pathname, query } = useRouter();

  const { SELF_REG_PROVIDER, IDENTITY_PROVIDERS } = useRuntimeConfig();
  const providers = IDENTITY_PROVIDERS?.providers;
  const selfRegWithProvider = SELF_REG_PROVIDER && providers && providers.length !== 0;
  const selfRegProvider = selfRegWithProvider && providers.find((p) => p?.provider === SELF_REG_PROVIDER);

  const signUpWithProvider = async () => {
    // @ts-ignore
    return Auth.federatedSignIn({ provider: selfRegProvider.provider });
  };

  const isWellbeing = pathname === '/wellbeinghub';
  const getSignUpQuery = () => {
    const sourceURL = sessionStorage.getItem('source_url');
    const signUpQuery: Record<string, string | string[]> = {
      ...query,
      ...(sourceURL && {
        source_url: sourceURL
      })
    };

    if (isWellbeing) signUpQuery.self_refer = '1';

    return signUpQuery;
  };

  // prettier-ignore
  if (selfRegProvider && selfRegProvider.provider === 'AXAPAT') { //NOSONAR
    return (
      <Hint paddingBottom>
        <Button
          type="link"
          data-testid="axa-sign-up-button"
          onClick={signUpWithProvider}
          css={css`
            font-weight: inherit;
          `}
        >
          {t('Register an account with AXA')}
        </Button>
      </Hint>
    );
  }

  return (
    <div style={{ display: 'flex', gap: 4 }}>
      <p>{t('Create an HBSUK account')}</p>
      <a
        href={`/patients/register?${new URLSearchParams(getSignUpQuery() as Record<string, string>).toString()}`}
        style={{ fontWeight: 600, textDecoration: 'underline' }}
      >
        {t('here.')}
      </a>
    </div>
  );
};

export default SelfRegLink;
